import '../scss/main.scss';
import 'slick-carousel/slick/slick.js';
import { smallBreakpoint } from 'frontend-library/src/utilities/js/mediaQueries';
(function ($, browser) {
    if (document.querySelectorAll('.js-hero-slider-wrapper,' +
        ' .js-hero-slider--2columns, .js-hero-slide').length > 0 &&
        typeof jQuery === 'function' && typeof jQuery.fn.slick === 'function') {
        // Hero toggle Class - Constructor (Pre Js ES5 way)
        var HeroToggle = function (element, parameters) {
            this.element = $(element);
            this.slickParameters = parameters;
        };
        // Adding a Method to disable the slider to the HeroToggle Class
        HeroToggle.prototype.disable = function () {
            var el = $(this.element);
            if (typeof el[0].slick !== 'undefined') {
                el.slick('unslick');
                //Chosen plugin stops working when slider is unslicked. This is to re-activate it. 
                var chosenElement = el.find('.chosen-container');
                if (chosenElement) {
                    var selectFields = el.find('select');
                    chosenElement.remove();
                    selectFields.css('display', 'inline-block').chosen({ "disable_search_threshold": 6 });
                }
            }
        };
        // Adding a Method to enable the slider to the HeroToggle Class
        HeroToggle.prototype.enable = function () {
            $(this.element).slick(this.slickParameters);
        };
        HeroToggle.prototype.prevArrow = '<span class="slick-prev"><i class="fa fa-chevron-left"></i></span>';
        HeroToggle.prototype.nextArrow = '<span class="slick-next"><i class="fa fa-chevron-right"></i></span>';
        // Sets of slider parameters
        var sliderConfigurations = {
            'js-hero-slider': {
                accessibility: false,
                dots: false,
                prevArrow: HeroToggle.prototype.prevArrow,
                nextArrow: HeroToggle.prototype.nextArrow,
                fade: true,
                infinite: false,
                autoplaySpeed: 5000,
                autoplay: false,
            },
            'js-hero-slider--2columns': {
                accessibility: false,
                dots: false,
                prevArrow: HeroToggle.prototype.prevArrow,
                nextArrow: HeroToggle.prototype.nextArrow,
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                autoplaySpeed: 5000,
                autoplay: false,
            },
        };
        $(browser).ready(function () {
            // Triggering all the functionality 200 milliseconds after for cases
            // when the slides are loaded through angular
            setTimeout(function () {
                var params = {};
                // Populating the params object
                for (var name in sliderConfigurations) {
                    if (jQuery('.js-hero-slider-wrapper').hasClass(name)) {
                        params = sliderConfigurations[name];
                        break;
                    }
                }
                // Instantiating the slider
                var slider = new HeroToggle('.js-hero-slider-wrapper', params);
                // Using the X axis breakpoint method to enable/disable the slider based
                browser.watchXAxisBreakpoint(smallBreakpoint - 1, slider.disable.bind(slider), slider.enable.bind(slider), true);
            }, 200);
        });
    }
}(jQuery, window));
